var _defs, _path, _rect, _path2, _polyline, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGastronomia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.57 79.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5656ff;}.cls-2{fill:none;stroke:#5656ff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.09px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.67,56.05h36.2S42,44,25.77,44,7.67,56.05,7.67,56.05Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.67,
    y: 59.71,
    width: 36.2,
    height: 4.64
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.67,67.78h36.2a0,0,0,0,1,0,0v1.8A2.84,2.84,0,0,1,41,72.42H10.51a2.84,2.84,0,0,1-2.84-2.84v-1.8A0,0,0,0,1,7.67,67.78Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "46.86 71.47 55.32 71.47 59.85 31.87 46.86 31.87 33.87 31.87 35.75 42.2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.86,
    y1: 20.42,
    x2: 46.86,
    y2: 31.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGastronomia);
export default __webpack_public_path__ + "static/media/Icon-gastronomia.c16960fa6c7668b499085900c21ce842.svg";
export { ForwardRef as ReactComponent };